<template>
    <BaseForm v-if="series && errors">
        <template #fields>
            <TextAreaField
                :value="values.locationRequirements"
                :label="$t('location-requirements')"
                :error-messages="errors.locationRequirements"
                :max-length="ProjectSeriesLocationSchema.shape.locationRequirements.maxLength ?? undefined"
                @input="setFieldValue('locationRequirements', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('locationRequirements', true)"
            />
            <TextAreaField
                :value="values.allocationHints"
                :label="$t('allocation-hints')"
                :error-messages="errors.allocationHints"
                :max-length="ProjectSeriesLocationSchema.shape.allocationHints.maxLength ?? undefined"
                @input="setFieldValue('allocationHints', ($event.target as HTMLInputElement).value)"
                @blur="setFieldTouched('allocationHints', true)"
            />
        </template>
    </BaseForm>
</template>
<script setup lang="ts">
import BaseForm from '@/components/Form/BaseForm.vue';
import TextAreaField from '@/components/Form/TextAreaField.vue';
import { useForm } from '@/forms/composables/useForm';
import { useProjectSeriesInjection } from '@/project/composables/useProjectSeriesInjection';
import { ProjectSeriesLocationSchema } from '@/project/schemas';
import { computed } from 'vue';
const props = defineProps<{ seriesId: string }>();

const seriesId = computed(() => props.seriesId);

const { series, updateProjectSeries } = useProjectSeriesInjection();

const { values, errors, setFieldValue, setFieldTouched, validate, onDiscard, resetForm } = useForm(
    ProjectSeriesLocationSchema,
    computed(() => ({
        locationRequirements: series.value?.locationRequirements ?? '',
        allocationHints: series.value?.allocationHints ?? '',
    })),
);

async function save() {
    const valid = await validate();
    if (valid) {
        await updateProjectSeries({ id: seriesId.value, ...values.value });
    }
}

defineExpose({ save, onDiscard, resetForm });
</script>
